import { Pipe, PipeTransform } from '@angular/core';

import { formatEnergyValue } from '../computations/energy';

@Pipe({
  name: 'avsEnergyValue',
})
export class EnergyValuePipe implements PipeTransform {
  transform(value: number | string | null, unit: string) {
    const numericValue = Number(value);
    const formatted = formatEnergyValue(numericValue, unit);
    const displayValue = formatted.value.toLocaleString('en-US', {
      maximumFractionDigits: 3,
      minimumFractionDigits: 0,
    });

    if (isNaN(numericValue)) {
      return '';
    }

    return `${displayValue} ${formatted.unit}`;
  }
}
